import {AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

enum TooltipPosition {
  'Left' = 'left',
  'Right' = 'right',
  'Top' = 'top',
  'TopLeft' = 'topLeft',
  'TopRight' = 'topRight',
  'Bottom' = 'bottom',
}

const DEFAULT_LENGTH_MULTIPLIER = 7.2;
const DEFAULT_ADDED_TEXT_COUNT = 5;

@Directive({
  selector: '[tooltip]',
})
export class TooltipDirective implements AfterViewInit {

  @Input() tooltipText;
  @Input() tooltipPosition: TooltipPosition;
  @Input() isVisible: boolean = true;

  spanElement: Renderer2;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  elementPosition: {x: number, y: number}

  ngAfterViewInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'clickatell-tooltip');
  }

  @HostListener('mouseover') onHover() {
    if(!this.isVisible) {
      return
    }
    const boundingClientRect = this.elementRef.nativeElement.getBoundingClientRect();
    this.elementPosition = {
      x: boundingClientRect.x,
      y: boundingClientRect.y
    }
    this.addTooltipDiv();
  }

  @HostListener('mouseout') onLeave() {
    this.removeTooltip();
  }

  removeTooltip() {
    if(!this.isVisible) {
      return
    }
    this.renderer.removeChild(this.elementRef.nativeElement, this.spanElement);
  }

  addTooltipDiv() {
    this.spanElement = this.renderer.createElement('span');

    this.renderer.setProperty(this.spanElement, 'innerHTML', this.tooltipText);

    this.changeStyles();
    this.renderer.appendChild(this.elementRef.nativeElement, this.spanElement);
  }

  changeStyles() {
    // this.spanWidth = this.length;
    switch (this.tooltipPosition) {
      case TooltipPosition.TopLeft:
        this.spanAddClass = 'clickatell-tooltip-text-topLeft';
        this.spanMarginLeft = this.length / 2;
        break;
      case TooltipPosition.TopRight:
        this.tooltipTopRight();
        break;
      case TooltipPosition.Bottom:
        this.spanAddClass = 'clickatell-tooltip-text-bottom';
        this.spanMarginLeft = (this.length - this.elementWidth) / 2;
        break;
      case TooltipPosition.Right:
        this.spanAddClass = 'clickatell-tooltip-text-right';
        this.spanSetTop = this.elementHeight;
        break;
      case TooltipPosition.Left:
        this.spanAddClass = 'clickatell-tooltip-text-left';
        this.spanSetTop = this.elementHeight;
        break;
      case TooltipPosition.Top:
      default:
        this.tooltipTop();
        break;
    }
  }

  private tooltipTop() {
    this.spanAddClass = 'clickatell-tooltip-text-top';
    const LEFT = ((this.elementRef.nativeElement.offsetWidth) - this.length) / 2;
    this.renderer.setStyle(this.spanElement, 'left', `${LEFT}px`);
  }

  private tooltipTopRight() {
    this.spanAddClass = 'clickatell-tooltip-text-topRight';
    const LEFT = ((this.elementPosition.x + this.elementRef.nativeElement.offsetWidth) - this.length) + 5;
    const TOP = ((this.elementPosition.y - this.elementRef.nativeElement.offsetHeight));
    this.renderer.setStyle(this.spanElement, 'left', `${LEFT}px`);
    this.renderer.setStyle(this.spanElement, 'position', 'fixed');
    this.renderer.setStyle(this.spanElement, 'top', `${TOP}px`);
    // this.renderer.setStyle(this.spanElement, 'bottom', "calc(10% + 10px)");
  }

  set spanWidth(pixels: number) {
    this.renderer.setStyle(this.spanElement, 'width', pixels + 'px');
  }

  set spanMarginLeft(pixels: number) {

    this.renderer.setStyle(this.spanElement, 'marginLeft', '-' + pixels + 'px');
  }

  set spanMarginRight(pixels: number) {

    this.renderer.setStyle(this.spanElement, 'marginRight', pixels + 'px');
  }

  set spanSetTop(pixels: number) {
    this.renderer.setStyle(this.spanElement, 'top', pixels + 'px');
  }

  set spanAddClass(className: string) {
    this.renderer.addClass(this.spanElement,"clickatell-tooltip-text");
    this.renderer.addClass(this.spanElement, className);
  }

  get length(): number {
    return (Math.round(this.tooltipText.length * DEFAULT_LENGTH_MULTIPLIER) + DEFAULT_ADDED_TEXT_COUNT);
  }

  get elementWidth() {
    const style =
        this.elementRef.nativeElement.currentStyle ||
        window.getComputedStyle(this.elementRef.nativeElement),
      width = this.elementRef.nativeElement.offsetWidth,
      margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
      border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return (width + margin - padding + border) / 2 - DEFAULT_ADDED_TEXT_COUNT * 2;
  }

  get elementHeight() {
    const style =
        this.elementRef.nativeElement.currentStyle ||
        window.getComputedStyle(this.elementRef.nativeElement),
      height = this.elementRef.nativeElement.offsetHeight,
      margin = parseFloat(style.marginBottom) + parseFloat(style.marginTop),
      padding = parseFloat(style.paddingBottom) + parseFloat(style.paddingTop),
      border = parseFloat(style.borderBottom) + parseFloat(style.borderTop);

    return (height + margin - padding + border) / 4;
  }
}
